import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import ThumbUp from '@mui/icons-material/ThumbUp';

import { Typo } from 'uikit/content';

import { truncate } from 'lodash';
import { CardMeta } from 'uikit/cards';
import VideoBrowseCardMedia from '../components/videoBrowseCardMedia';

import styles from '../styles/videosListItem.module.scss';

import VideoImage from '../images/default_on_demand_cover.png';
import TopicImage from '../images/default_topic_cover.svg';

export default function VideosListItem({
  title,
  description,
  image,
  duration,
  voteTotal,
  videoType,
  link,
  isComplete,
}) {
  return (
    <Link to={link} className={styles.item} id="video-live-and-upcoming-card">
      <div className={classnames(styles.cover_art, { [styles.isComplete]: isComplete })}>
        <div className={classnames(styles.image_container, styles[`image_container_${videoType}`])}>
          {image || videoType === 'video'
            ? <img src={image || VideoImage} alt="" />
            : <TopicImage />}
        </div>
        <VideoBrowseCardMedia isComplete={isComplete} duration={duration} type={videoType} folderIconClassName={styles.folder} />
      </div>

      <div>
        <Typo className={styles.title} element="h3" variant="heading5" modifier="semi">
          {title}
        </Typo>
        <Typo className={styles.title} element="p" variant="body3">
          {truncate(description, { length: 325 })}
        </Typo>
        <div className={styles.metaContainer}>
          {videoType === 'video' && voteTotal > 0
        && <CardMeta className={styles.meta} icon={<ThumbUp />} text={`+${voteTotal}`} />}
        </div>
      </div>
    </Link>
  );
}
